import {AboutComponent} from "../components/AboutComponent.tsx";

export const AboutPage = () => {
    return <AboutComponent/>
};
